<template>
  <div v-loading="loading">
    <el-form ref="form" :model="form" label-width="250px" @submit.prevent="onSubmit"
      style="margin: 20px; width: 60%; min-width: 600px">
      <el-form-item label="Zone ID">
        <el-input v-model="form.zoneId" type="text" readonly></el-input>
      </el-form-item>
      <el-form-item label="Software Version">
        <el-input v-model="form.softwareVersion" type="text" readonly></el-input>
      </el-form-item>
      <el-form-item label="Bacnet">
        <el-checkbox v-model="form.bacnetEnabled" @change="bacnetEnabledCheckboxChange"></el-checkbox>
      </el-form-item>
      <el-form-item style="margin-top: 10px">
        <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
      </el-form-item>
      <input style="color: white; outline: none; border: none" ref="hidden" />
    </el-form>
  </div>
</template>

<script>
import Axios from "axios"
import IOService from "@/api/io.service"
import SettingsService from "@/api/settings.service"

export default {
  data() {
    return {
      loading: false,
      form: {
        zoneId: "",
        softwareVersion: "",
        bacnetEnabled: false
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      user: this.$session.get("User")
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    saveDataToPanel() {
      this.loading = true
      Axios.all([
        SettingsService.changeSetting(this.user.activeZone, "Settings.System.Bacnet.Enabled", this.form.bacnetEnabled ? "true" : "false"),
      ])
        .then(
          Axios.spread((bacnetEnabledResponse) => {
            //The system should update in 10 seconds.
            this.loading = false
            if (bacnetEnabledResponse.data.result != "success") {
              const h = this.$createElement
              this.$notify({
                title: "Bacnet Enable/Disable",
                message: "Error trying to save data to panel",
                type: "error"
              })
            } else {
              this.$notify({
                title: "Bacnet Enable/Disable",
                message: "Settings Saved to Panel",
                type: "info"
              })
            }
          })
        )
        .catch(() => {
          this.loading = false
          const h = this.$createElement
          this.$notify({
            title: "Bacnet Enable/Disable",
            message: "Error trying to save data to panel",
            type: "error"
          })
        })
    },
    getData() {
      //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
      Axios.all([IOService.getSettings(this.user.activeZone)]).then(
        Axios.spread((settingsResponse) => {
          this.form.zoneId = this.user.activeZone
          this.form.softwareVersion = settingsResponse.data.system.softwareVersion == null ? "" : settingsResponse.data.system.softwareVersion
          this.form.bacnetEnabled = settingsResponse.data.system.bacnet.enabled == 'true';

        })
      )
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}

/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// System.vue?79167f88